import type { CreateInquiryRequest, CreateInquiryResult, InquiryDto } from "./contracts";
import { getApiBaseUrl, getDataSource } from "./source";

// Local
import {
  addInquiry,
  loadInquiries,
  deleteInquiry,
} from "@/lib/storage/inquiriesStorage";

export async function createInquiry(req: CreateInquiryRequest): Promise<CreateInquiryResult> {
  const source = getDataSource();

  if (source === "http") {
    const base = getApiBaseUrl();
    const res = await fetch(`${base}/api/inquiries`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(req),
    });
    if (!res.ok) throw new Error(`createInquiry failed: ${res.status}`);
    return (await res.json()) as CreateInquiryResult;
  }

  const created = addInquiry(req); // assumes local helper creates full Inquiry object
  return { id: created.id, createdAt: created.createdAt };
}

export async function listInquiries(): Promise<InquiryDto[]> {
  const source = getDataSource();

  if (source === "http") {
    const base = getApiBaseUrl();
    const res = await fetch(`${base}/api/inquiries`, { cache: "no-store" });
    if (!res.ok) throw new Error(`listInquiries failed: ${res.status}`);
    const data = await res.json();
    return (data.items ?? data) as InquiryDto[];
  }

  return loadInquiries() as InquiryDto[];
}

export async function removeInquiry(id: string): Promise<void> {
  const source = getDataSource();

  if (source === "http") {
    const base = getApiBaseUrl();
    const res = await fetch(`${base}/api/inquiries/${encodeURIComponent(id)}`, {
      method: "DELETE",
    });
    if (!res.ok && res.status !== 404) throw new Error(`removeInquiry failed: ${res.status}`);
    return;
  }

  deleteInquiry(id);
}
